import {
  WebTracerProvider,
  BatchSpanProcessor,
} from "@opentelemetry/sdk-trace-web";
import { DocumentLoadInstrumentation } from "@opentelemetry/instrumentation-document-load";
import { UserInteractionInstrumentation } from "@opentelemetry/instrumentation-user-interaction";
import { ZoneContextManager } from "@opentelemetry/context-zone";
import { registerInstrumentations } from "@opentelemetry/instrumentation";
import { XMLHttpRequestInstrumentation } from "@opentelemetry/instrumentation-xml-http-request";
import { FetchInstrumentation } from "@opentelemetry/instrumentation-fetch";
import {
  defaultResource,
  resourceFromAttributes,
} from "@opentelemetry/resources";
import {
  ATTR_SERVICE_NAME,
  ATTR_SERVICE_VERSION,
} from "@opentelemetry/semantic-conventions";
import { OTLPTraceExporter } from "@opentelemetry/exporter-trace-otlp-http";
import {
  otelEnableEnvVar,
  otelServiceNameEnvVar,
  otelServiceVersionEnvVar,
  otelExporterOtlpEndpointEnvVar,
  otelExporterAuthTokenEnvVar,
} from "./cloud-connect/feature-toggles/feature-toggles";

const resource = defaultResource().merge(
  resourceFromAttributes({
    [ATTR_SERVICE_NAME]: otelServiceNameEnvVar(),
    [ATTR_SERVICE_VERSION]: otelServiceVersionEnvVar(),
  }),
);

const otlpExporter = new OTLPTraceExporter({
  url: otelExporterOtlpEndpointEnvVar(),
  headers: {
    Authorization: `Bearer ${otelExporterAuthTokenEnvVar()}`,
  },
});

console.log("OTEL Configuration:", {
  enabled: otelEnableEnvVar(),
  hasEndpointConfigured: !!otelExporterOtlpEndpointEnvVar(),
  serviceName: otelServiceNameEnvVar(),
  hasAuthToken: !!otelExporterAuthTokenEnvVar(),
});

if (otelEnableEnvVar()) {
  const provider = new WebTracerProvider({
    resource,
    spanProcessors: [
      new BatchSpanProcessor(otlpExporter, {
        maxQueueSize: 75, // maximum queue size. After the size is reached, spans are dropped.
        maxExportBatchSize: 10, // maximum batch size of every export. It must be smaller or equal to maxQueueSize.
        scheduledDelayMillis: 500, // interval between two consecutive exports
        exportTimeoutMillis: 25000, // how long the export can run before it is cancelled
      }),
    ],
  });

  provider.register({
    contextManager: new ZoneContextManager(),
  });

  const traceConfigs = {
    // matches tomorrowthings subdomains (e.g., api.tomorrowthings.dev or rag.tomorrowthings.ai)
    // whitelists matching domains for trace propagation
    propagateTraceHeaderCorsUrls: [
      /^(https?:\/\/)?([a-zA-Z0-9-]+\.)?tomorrowthings\.(dev|ai)(?=\/|$)/,
    ],
  };

  // registering instrumentations
  registerInstrumentations({
    instrumentations: [
      new DocumentLoadInstrumentation(), // for document load events
      new UserInteractionInstrumentation(), // optional, but may be useful to have traces for user interactions
      new XMLHttpRequestInstrumentation(traceConfigs), // for browser XHR calls (like axios)
      new FetchInstrumentation(traceConfigs), // for browser fetch api
    ],
  });
}
